export default function StatusBadge({ status }) {
  const map = {
    pending: "bg-slate-200/70 text-slate-700",
    approved: "bg-green-100 text-green-800",
    verified: "bg-green-100 text-green-800",
    rejected: "bg-red-100 text-red-700",
    Eligible: "bg-slate-100 text-slate-700",
    Enrolled: "bg-blue-100 text-blue-800",
    Active: "bg-green-100 text-green-800",
    Withdrawn: "bg-slate-200 text-slate-500 line-through",
    "Needs capacity": "bg-red-50 text-[#c8102e]",
  };
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${map[status] || "bg-slate-100 text-slate-600"}`} data-testid={`status-badge-${status}`}>
      {status}
    </span>
  );
}
